const slides = [
    {
        text: 'leads by example',
        media: 'Ryan_Wildman',
        type: 'image',
        desktop: {
            offset: 12,
            degree: 0
        },
        mobile: {
            offset: 115,
            degree: 0
        },
        story: {
            id: 1
        }
    }, {
        text: 'insatiable curiosity',
        media: 'Anthony_Jay',
        type: 'image',
        desktop: {
            offset: 100,
            degree: 30
        },
        mobile: {
            offset: 0,
            degree: 60
        },
        story: {
            id: 2
        }
    }, {
        text: 'courage to grow',
        media: 'Jessica_Eisenhauer',
        type: 'image',
        desktop: {
            offset: 90,
            degree: 85
        },
        mobile: {
            offset: 90,
            degree: 5
        },
        story: {
            id: 3
        }
    }, {
        text: `walks in others&rsquo; shoes`,
        media: 'Rob_Zompanti',
        type: 'image',
        desktop: {
            offset: 90,
            degree: -80,
        },
        mobile: {
            offset: 0,
            degree: 60,
        },
        story: {
            id: 4
        }
    }
]

export default {
    student: slides,
    experienced: slides,
}